var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluationsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.00766H11.82C11.4 0.848775 10.3 0.00958252 9 0.00958252C7.7 0.00958252 6.6 0.848775 6.18 2.00766H2C0.9 2.00766 0 2.9068 0 4.00574V17.9923C0 19.0912 0.9 19.9904 2 19.9904H16C17.1 19.9904 18 19.0912 18 17.9923V4.00574C18 2.9068 17.1 2.00766 16 2.00766ZM9 2.00766C9.55 2.00766 10 2.45723 10 3.0067C10 3.55617 9.55 4.00574 9 4.00574C8.45 4.00574 8 3.55617 8 3.0067C8 2.45723 8.45 2.00766 9 2.00766ZM11 15.9942H4V13.9961H11V15.9942ZM14 11.998H4V9.99997H14V11.998ZM14 8.00189H4V6.00382H14V8.00189Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationsWhite);
export default __webpack_public_path__ + "static/media/evaluations_white.04642fa412ac628810618159735cabcb.svg";
export { ForwardRef as ReactComponent };